
// Đăng ký GSAP plugin một lần duy nhất
if (window.gsap && window.SplitText && window.ScrollTrigger) {

  gsap.registerPlugin(SplitText, ScrollTrigger);
  
  // Set GSAP defaults
  gsap.defaults({
    ease: "power2.inOut",
    duration: 1
  });
}

// const { registerLenisDirective } = require("./js/alpine-lenis.js");
const { registerSliders } = require("./js/alpine-sliders.js");
const { registerTextDirectives } = require("./js/alpine-text.js");
const { registerCustomDirectives } = require("./js/alpine-custom.js");
const { registerVideoDirectives } = require("./js/alpine-video.js");
const { registerImageDirectives } = require("./js/alpine-image.js");
const { registerButtonDirectives } = require("./js/alpine-button.js");
const { registerAlpineAnimation } = require("./js/alpine-animation.js");
const { registerWpformDirectives } = require("./js/alpine-wpforms.js");

const bootEsgEffects = () => {
  if (window.__esgEffectsBooted) return;
  if (!window.gsap || !window.ScrollTrigger) return;
  registerEsgEffects();
  window.__esgEffectsBooted = true;
};

document.addEventListener("alpine:init", () => {
  // registerLenisDirective(Alpine);
  registerButtonDirectives(Alpine);
  registerImageDirectives(Alpine);
  registerSliders(Alpine);
  registerTextDirectives(Alpine);
  registerCustomDirectives(Alpine);
  registerVideoDirectives(Alpine);
  registerAlpineAnimation(Alpine);
  registerWpformDirectives(Alpine);

});

document.addEventListener("DOMContentLoaded", () => {
  bootEsgEffects();
});

window.addEventListener("load", () => {
  bootEsgEffects();
  setTimeout(() => {
    if (window.ScrollTrigger) {
      window.ScrollTrigger.refresh();
    }
  }, 250);
});

document.addEventListener("lity:open", () => {
  const iframe = document.querySelector(".lity iframe");
  if (!iframe) return;

  let src = iframe.getAttribute("src") || "";
  if (src.includes("autoplay=")) return;

  const sep = src.includes("?") ? "&" : "?";
  iframe.setAttribute("src", `${src}${sep}autoplay=1&mute=1`);
});

document.addEventListener('DOMContentLoaded', function() {
    // Initialize SSD Swiper
    const ssdSwiper = new Swiper('.ssdSwiper', {
        slidesPerView: 1,
        spaceBetween: 24,
        pagination: { el: '.ssdSwiper .swiper-pagination', clickable: true },
        breakpoints: {
            768: { slidesPerView: 2, spaceBetween: 48 },
            1280: { slidesPerView: 2, spaceBetween: 80 },
        },
    });

    // Initialize DRAM Swiper
    const dramSwiper = new Swiper('.dramSwiper', {
        slidesPerView: 1,
        spaceBetween: 24,
        pagination: { el: '.dramSwiper .swiper-pagination', clickable: true },
        breakpoints: {
            768: { slidesPerView: 2, spaceBetween: 48 },
            1280: { slidesPerView: 2, spaceBetween: 80 },
        },
    });

    window.ssdSwiper = ssdSwiper;
    window.dramSwiper = dramSwiper;
});
